
import miniIconMenu from "../components/cms/horizontalMiniIconMenu.vue"
import banner from "../components/cms/banner.vue"
import { getHomeData } from "../api/gateway"
import getCartNumMixin from "@/mixins/getCartNum"
import commonConfig from "@/utils/common"
import ObserverHOC from "@/components/ObserverHOC"
import { trackViewItemList } from "@/utils/track"
import { getHeadLink, insertScript, getHeadMeta } from "@/utils/head"
import { getRequestHeaders, getLoginStatus, formatProductParamsBy } from "@/utils/utils"
import { Logger } from "@/plugins/logger"
const wareTemplete = () => import("../components/cms/wareTemplete.vue")
export default {
  components: {
    miniIconMenu,
    wareTemplete,
    banner,
    ObserverHOC
  },
  mixins: [getCartNumMixin],
  props: {
    configs: {
      type: Object,
      default: () => {}
    }
  },
  async asyncData({ req, error, store, app, $cookies }) {
    try {
      const { data } = await getHomeData(
        {
          param: formatProductParamsBy({}, $cookies),
          comm: {}
        },
        {
          loading: true,
          headers: getRequestHeaders({ req, store })
        }
      )
      const favicon = commonConfig.favicon
      const lang = store.state.lang
      return {
        pageTitle: data?.titleF?.replace(/^\$/, "") || app.i18n.t("page.title"), // TODO 待调整 按照后端返回的来
        description: app.i18n.t("page.description"),
        cmsData: data.cmsConfig,
        favicon,
        lang: lang == "en_US" ? "en" : "zh-hant"
      }
    } catch (err) {
      Logger.error("首页初始化报错", err)
      error({
        statusCode: 500,
        message: "Internal Server Error"
      })
    }
  },
  data() {
    return {
      keyword: "",
      cmsData: [],
      isOnline: "",
      cartList: [],
      favicon: "",
      lang: ""
    }
  },
  head() {
    return {
      title: this.pageTitle,
      meta: [
        { hid: "description", name: "description", content: this.description },
        { name: "og:type", content: "website" },
        { name: "og:title", content: this.pageTitle },
        { name: "og:description", content: this.description },
        { name: "google-site-verification", content: "DEZxSQV2yKcB_MwL4MUiQZqrJNWCz_W9EB8uC6BxPvg" },
        ...getHeadMeta(this)
      ],
      link: getHeadLink(this),
      script: [...insertScript.script],
      noScript: [...insertScript.noScript],
      __dangerouslyDisableSanitizersByTagID: {
        ...insertScript.disableSanitizers
      }
    }
  },
  computed: {},
  created() {
    const { isOnline } = getLoginStatus()
    this.isOnline = isOnline
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.$bus.$off("getCartSkuList")
  },
  methods: {
    init() {
      // 组装已加购数据
      this.$bus.$on("getCartSkuList", val => {
        this.cartList = val
        const selWares = {}
        this.cartList.forEach(item => {
          selWares[item.sku] = { count: item.count, stock: item.stock }
        })
        this.cmsData.forEach(cmsItem => {
          if (cmsItem.type == 26) {
            cmsItem.subConfigList.forEach(ware => {
              if (selWares[ware?.additional?.sku]) {
                this.$set(ware, "addCartCount", selWares[ware.additional.sku].count)
                this.$set(ware, "stock", selWares[ware.additional.sku].stock)
              } else {
                this.$set(ware, "addCartCount", 0)
              }
            })
          }
          return cmsItem
        })
      })
    },
    handleVisibility(index) {
      trackViewItemList(this.cmsData[index].subConfigList)
    }
  }
}
